import { gql } from "@apollo/client"

export const GET_TOURNAMENT_ROUND = gql`
  query TournamentRound($id: Int!) {
    TournamentRound(id: $id) {
      id
      name
      sortOrder
      description
      urlView
      urlStanding
      statusId
      TournamentMatches(paginate: 99999) {
        id
        tournamentId
        roundId
        table
        reported
        draw
        dropPlayer
        dropOpponent
        winnerVictories
        loserVictories
        playerId
        opponentId
        winnerId
        loserId
        modified
        Player {
          id
          drop
          raceId
          points
          Person {
            id
            avatar
            name
            fullName
            urlAvatar
            phone
            code
          }
        }
        Opponent {
          id
          drop
          raceId
          points
          Person {
            id
            avatar
            name
            fullName
            urlAvatar
            phone
            code
          }
        }
        ModifiedBy {
          id
          fullName
        }
      }
    }
  }
`
export const GET_TOURNAMENT_ROUND_SIMPLE = gql`
  query TournamentRound($id: Int!) {
    TournamentRound(id: $id) {
      id
      name
      sortOrder
      description
      urlView
      urlStanding
      statusId
    }
  }
`
